import { Icon } from "./Icon.tsx";

/** A small "i" icon with a native tooltip (title) — for the rare case a
    field genuinely needs explaining (a SWMM formula coefficient, not how
    the app itself works), instead of a permanent paragraph of prose that
    would sit in the dialog and crowd every other field, explained or not
    (this app's own compact-dialog style; also the pattern evalhid-web's own
    InfoIcon.tsx uses). */
export function InfoIcon({ text }: { text: string }) {
  return (
    <span className="info-icon" title={text} aria-label={text} tabIndex={0}>
      <Icon>
        <circle cx="12" cy="12" r="9" />
        <line x1="12" y1="11" x2="12" y2="16" />
        <circle cx="12" cy="8" r="1" fill="currentColor" stroke="none" />
      </Icon>
    </span>
  );
}
